module.exports = __webpack_public_path__ + "static/media/black.796b9af5.png";